import { render, staticRenderFns } from "./IndicadorRentabilidadOrdenes.vue?vue&type=template&id=452b62bd&"
import script from "./IndicadorRentabilidadOrdenes.vue?vue&type=script&lang=js&"
export * from "./IndicadorRentabilidadOrdenes.vue?vue&type=script&lang=js&"
import style0 from "./IndicadorRentabilidadOrdenes.vue?vue&type=style&index=0&id=452b62bd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports